import moment from "moment";

export const calculateNumberOfDays = (from, to) => {
  if (from == null || to == null) return null;
  const mFrom = moment(from);
  const mTo = moment(to);
  if (!mFrom.isValid() || !mTo.isValid()) return null;
  const d = mTo.diff(mFrom, "days");
  return Number.isFinite(d) ? d : null;
};
